<template>
  <b-modal
    v-model="show"
    size="lg"
    title="Time off report"
    :modal-class="isLoading ? 'time-off-report loading' : 'time-off-report'"
    centered
  >
    <div class="mb-2">
      <TableUserItem :user="user" :user-tooltip="false"/>
    </div>
    <b-card no-body>
      <b-tabs card v-if="timeOffReportData.length" v-model="timeOffTabIndex">
        <b-tab
          v-for="yearData in timeOffReportData"
          :key="yearData.year"
          :title="yearData.year + ''">
          <div class="row">
            <div class="col-4" v-for="timeOffTypeData in yearData.items" :key="timeOffTypeData.type">
              <div>{{timeOffTypeData.type}} {{timeOffTypeData.days}} d</div>
              <template v-for="monthData in timeOffTypeData.items">
                <div
                  class="cursor-pointer"
                  :class="{'visible': visibleItems[timeOffTypeData.type + '_' + monthData.month]}"
                  :key="timeOffTypeData.type + '_' + monthData.month + '_head'"
                  @click="toggleVisibleItem(timeOffTypeData.type, monthData.month)"
                >
                  <i class="arrow" :class="{'up': visibleItems[timeOffTypeData.type + '_' + monthData.month], 'down': !visibleItems[timeOffTypeData.type + '_' + monthData.month]}"></i>
                  {{monthData.month}}, {{monthData.days}} d
                </div>
                <b-collapse
                  :id="`collapse-` + monthData.month + '_body'"
                  :key="timeOffTypeData.type + '_' + monthData.month"
                  v-model="visibleItems[timeOffTypeData.type + '_' + monthData.month]"
                >
                  <ul>
                    <li
                      v-for="(timeOff, index) in monthData.items"
                      :key="index">
                      {{timeOff.start}}<template v-if="timeOff.start !== timeOff.end"> - {{timeOff.end}}</template> - {{timeOff.days}} d
                    </li>
                  </ul>
                </b-collapse>
              </template>
            </div>
          </div>
        </b-tab>
      </b-tabs>
      <b-tabs card v-if="workedDaysReportData.length" v-model="workedDaysTabIndex">
        <b-tab
          class="overflow-auto"
          v-for="yearData in workedDaysReportData"
          :key="yearData.year"
          :title="yearData.year + ''">
          <WorkedDaysReportTable
            :year="yearData.year"
            :reportData="yearData.year_items"
            :workingDaysInYear="yearData.working_days_count"
            hideUser
            @dataUpdated="dataUpdated"
          />
        </b-tab>
      </b-tabs>
    </b-card>
    <template v-slot:modal-footer><span /></template>
  </b-modal>
</template>

<script>
import TableUserItem from '@tables/TableUserItem.vue'
import WorkedDaysReportTable from '@components/tables/WorkedDaysReportTable'
export default {
  name: 'TimeOffReportModal',
  components: {
    TableUserItem,
    WorkedDaysReportTable
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default () {
        return {}
      }
    },
    timeOffReportData: {
      type: Array,
      default () {
        return []
      }
    },
    workedDaysReportData: {
      type: Array,
      default () {
        return []
      }
    },
    value: {
      type: Boolean
    }
  },
  data () {
    return {
      timeOffTabIndex: 0,
      workedDaysTabIndex: 0,
      visibleItems: {}
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    toggleVisibleItem (timeOffType, month) {
      this.visibleItems[timeOffType + '_' + month] = !this.visibleItems[timeOffType + '_' + month]
      this.$forceUpdate()
    },
    getWorkedDaysItemData (item) {
      return item[0]['data']
    },
    dataUpdated () {
      this.$emit('dataUpdated')
    }
  }
}
</script>
